import { Report } from '../types/reports.types';
import { getStageFromStatus } from './statusMapping';

/**
 * Transform a report to ExpertiseCard format
 */
export const transformReportForCard = (report: Report, t: any) => {
  const tags = [];
  const stageId = getStageFromStatus(report.status);
  
  // Add payment status tag
  if (report.payment?.status) {
    switch (report.payment.status) {
      case 'paid':
        tags.push(t('common.paid'));
        break;
      case 'unpaid':
        tags.push(t('common.unpaid'));
        break;
      case 'partial':
        tags.push(t('banque.reports.partial'));
        break;
      case 'refunded':
        tags.push(t('banque.reports.refunded'));
        break;
    }
  }
  
  // Add invoice status if relevant
  if (report.invoice?.issued) {
    tags.push(t('banque.reports.invoiceIssued'));
  }

  // Build full client name with contact info for display
  let clientDisplay = report.client?.name || t('banque.reports.clientNotSpecified');
  if (report.client?.phone) {
    clientDisplay += ` - ${report.client.phone}`;
  }
  if (report.client?.email) {
    clientDisplay += ` - ${report.client.email}`;
  }

  // Map to ExpertiseCardProps interface
  return {
    // Core data (required)
    id: String(report.id),
    reference: String(report.id),
    title: report.title || t('banque.reports.financialReport'),
    status: 'en_cours' as const, // Map to valid ExpertiseStatus
    statusDisplay: report.status || 'pending', // Use actual backend status for display
    
    // Display variant
    variant: 'standard' as const,
    
    // Common fields
    clientName: clientDisplay,
    expertName: report.expert?.name || t('banque.reports.expertNotAssigned'),
    createdAt: report.created_date || undefined,
    updatedAt: report.completed_date || report.created_date || undefined,
    dueDate: report.invoice?.due_date || undefined,
    
    // Address information
    address: report.property?.address ? {
      street: report.property.address.join(', '),
      city: undefined,
      postalCode: undefined,
      country: t('banque.reports.france')
    } : undefined,
    
    // Financial information
    amount: report.amount,
    currency: report.currency || 'EUR',
    paid: report.payment?.status === 'paid',
    perception: report.payment?.perception,
    invoiceStatus: report.invoice?.issued ? 'emise' : undefined,
    invoiceIssued: report.invoice?.issued,
    
    // Progress information
    progress: undefined,
    stage: report.status || 'pending',
    stageId: stageId,
    priority: 'medium' as const,
    
    // Tags and categories
    tags,
    category: 'reports' as const,
    type: report.type || t('banque.reports.financialReport'),
    
    // Description and notes  
    description: report.description,
    notes: undefined,
    
    // Statistics
    documentsCount: undefined,
    messagesCount: undefined,
    tasksCompleted: undefined,
    tasksPending: undefined,
    
    // UI customization
    className: undefined,
    showActions: true,
    selectable: false,
    selected: false,
    disabled: false,
    loading: false
  };
};